import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
export function confirmAlert(options) {
    const { customUI, title, message, buttons, closeOnEscape = true, closeOnClickOutside = true, } = options;
    const div = document.createElement('div');
    document.body.appendChild(div);
    const root = createRoot(div);
    const onClose = () => {
        Promise.resolve(root.unmount()).then(() => {
            if (div.parentNode) {
                div.parentNode.removeChild(div);
            }
        });
    };
    const AlertWrapper = () => {
        useEffect(() => {
            if (!closeOnEscape)
                return;
            const handleKeyDown = (e) => {
                if (e.key === 'Escape')
                    onClose();
            };
            window.addEventListener('keydown', handleKeyDown);
            return () => window.removeEventListener('keydown', handleKeyDown);
        }, []);
        const handleOverlayClick = (e) => {
            if (!closeOnClickOutside)
                return;
            if (e.target.classList.contains('react-confirm-alert-overlay')) {
                onClose();
            }
        };
        return (_jsx("div", { className: "react-confirm-alert-overlay", onClick: handleOverlayClick, children: _jsx("div", { className: "react-confirm-alert", children: customUI ? (customUI({ onClose })) : (_jsxs("div", { className: "react-confirm-alert-body", children: [title && _jsx("h1", { children: title }), message && _jsx("p", { children: message }), buttons && buttons.length > 0 && (_jsx("div", { className: "react-confirm-alert-button-group", children: buttons.map((btn, index) => (_jsx("button", { className: "btn btn-primary", onClick: () => {
                                    if (btn.onClick)
                                        btn.onClick();
                                    onClose();
                                }, children: btn.label }, index))) }))] })) }) }));
    };
    // In den DOM rendern
    root.render(_jsx(AlertWrapper, {}));
}
